export default "__VITE_ASSET__a1wR21WE__"